import { Routes } from '@angular/router';

import { LayoutComponent } from './layout/components/layout/layout.component';
import { AdminLayoutComponent } from './layout/components/admin-layout/admin-layout.component';
import { HomeComponent } from './pages/components/home/home.component';
import { QuranComponent } from './pages/components/quran/quran.component';
import { QuranSurahsComponent } from './pages/components/quran-surahs/quran-surahs.component';
import { DuasAzkarComponent } from './pages/components/duas-azkar/duas-azkar.component';
import { AmaalPlannerComponent } from './pages/components/amaal-planner/amaal-planner.component';
import { QiblaFinderComponent } from './pages/components/qibla-finder/qibla-finder.component';
import { HistoryComponent } from './pages/components/history/history.component';
import { MasjidsComponent } from './pages/components/masjids/masjids.component';
import { NamesOfAllahComponent } from './pages/components/names-of-allah/names-of-allah.component';
import { PrayerTimesComponent } from './pages/components/prayer-times/prayer-times.component';
import { DashboardComponent } from './pages/components/dashboard/dashboard.component';
import { IslamicCalendarComponent } from './pages/components/islamic-calendar/islamic-calendar.component';
import { IslamicLibraryComponent } from './pages/components/islamic-library/islamic-library.component';
import { KazaTrackerComponent } from './pages/components/kaza-tracker/kaza-tracker.component';
import { TasbeehCounterComponent } from './pages/components/tasbeeh-counter/tasbeeh-counter.component';
import { KidsModeComponent } from './pages/components/kids-mode/kids-mode.component';
import { SettingsComponent } from './pages/components/settings/settings.component';
import { OverviewComponent } from './admin/components/overview/overview.component';
import { LoginComponent } from './auth/components/login/login.component';
import { RegisterComponent } from './auth/components/register/register.component';
import { ForgotPasswordComponent } from './auth/components/forgot-password/forgot-password.component';
import { AccessDeniedComponent } from './pages/components/access-denied/access-denied.component';
import { PageNotFoundComponent } from './pages/components/page-not-found/page-not-found.component';
import { roleGuard } from './core/guards/role.guard';
import { authGuard } from './core/guards/auth.guard';
import { ROUTE_SEGMENTS } from './core/constants/routes.constants';

export const routes: Routes = [
  {
    path: ROUTE_SEGMENTS.AUTH,
    children: [
      { path: ROUTE_SEGMENTS.LOGIN, component: LoginComponent },
      { path: ROUTE_SEGMENTS.REGISTER, component: RegisterComponent },
      { path: ROUTE_SEGMENTS.FORGOT_PASSWORD, component: ForgotPasswordComponent }
    ]
  },
  {
    path: ROUTE_SEGMENTS.ADMIN,
    component: AdminLayoutComponent,
    canActivate: [roleGuard(['admin'])],
    children: [{ path: ROUTE_SEGMENTS.HOME, pathMatch: 'full', component: OverviewComponent }]
  },
  {
    path: ROUTE_SEGMENTS.DASHBOARD,
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: ROUTE_SEGMENTS.HOME, pathMatch: 'full', component: DashboardComponent },
      { path: 'quran/surahs', component: QuranSurahsComponent },
      { path: ROUTE_SEGMENTS.QURAN, component: QuranComponent },
      { path: ROUTE_SEGMENTS.DUAS_AZKAR, component: DuasAzkarComponent },
      { path: ROUTE_SEGMENTS.AMAAL_PLANNER, component: AmaalPlannerComponent },
      { path: ROUTE_SEGMENTS.QIBLA_FINDER, component: QiblaFinderComponent },
      { path: ROUTE_SEGMENTS.HISTORY, component: HistoryComponent },
      { path: ROUTE_SEGMENTS.MASJIDS, component: MasjidsComponent },
      { path: ROUTE_SEGMENTS.NAMES_OF_ALLAH, component: NamesOfAllahComponent },
      { path: ROUTE_SEGMENTS.PRAYER_TIMES, component: PrayerTimesComponent },
      { path: ROUTE_SEGMENTS.ISLAMIC_CALENDAR, component: IslamicCalendarComponent },
      { path: ROUTE_SEGMENTS.ISLAMIC_LIBRARY, component: IslamicLibraryComponent },
      { path: ROUTE_SEGMENTS.KAZA_TRACKER, component: KazaTrackerComponent },
      { path: ROUTE_SEGMENTS.TASBEEH_COUNTER, component: TasbeehCounterComponent },
      { path: ROUTE_SEGMENTS.KIDS_MODE, component: KidsModeComponent },
      { path: ROUTE_SEGMENTS.SETTINGS, component: SettingsComponent }
    ]
  },
  {
    path: ROUTE_SEGMENTS.HOME,
    component: LayoutComponent,
    children: [
      { path: ROUTE_SEGMENTS.HOME, pathMatch: 'full', component: HomeComponent },
      { path: 'quran/surahs', component: QuranSurahsComponent },
      { path: ROUTE_SEGMENTS.QURAN, component: QuranComponent },
      { path: ROUTE_SEGMENTS.DUAS_AZKAR, component: DuasAzkarComponent },
      { path: ROUTE_SEGMENTS.AMAAL_PLANNER, component: AmaalPlannerComponent },
      { path: ROUTE_SEGMENTS.QIBLA_FINDER, component: QiblaFinderComponent },
      { path: ROUTE_SEGMENTS.HISTORY, component: HistoryComponent },
      { path: ROUTE_SEGMENTS.MASJIDS, component: MasjidsComponent },
      { path: ROUTE_SEGMENTS.NAMES_OF_ALLAH, component: NamesOfAllahComponent },
      { path: ROUTE_SEGMENTS.PRAYER_TIMES, component: PrayerTimesComponent }
    ]
  },
  { path: ROUTE_SEGMENTS.ACCESS_DENIED, component: AccessDeniedComponent },
  { path: '**', component: PageNotFoundComponent }
];
